var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapseRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.6589 9.1589L6.29876 7.51223L4.6589 5.86556C4.59336 5.80444 4.54544 5.72671 4.52021 5.64054C4.49497 5.55438 4.49334 5.46297 4.5155 5.37596C4.53766 5.28894 4.58278 5.20953 4.6461 5.14611C4.70943 5.08268 4.78863 5.03758 4.87534 5.01556C4.9619 4.99335 5.05282 4.99494 5.13856 5.02016C5.2243 5.04538 5.3017 5.0933 5.36265 5.15889L7.35438 7.15889C7.44762 7.25264 7.5 7.37973 7.5 7.51223C7.5 7.64473 7.44762 7.77181 7.35438 7.86556L5.36265 9.86556C5.26828 9.95399 5.1434 10.0022 5.01434 9.99993C4.88528 9.99769 4.76213 9.94521 4.67085 9.85356C4.57958 9.76191 4.52733 9.63825 4.5251 9.50865C4.52287 9.37906 4.57084 9.25366 4.6589 9.1589Z",
    fill: "#5C5C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.4 0H14.6C15.3728 0 16 0.6272 16 1.4V14.6C16 14.9713 15.8525 15.3274 15.5899 15.5899C15.3274 15.8525 14.9713 16 14.6 16H1.4C1.0287 16 0.672602 15.8525 0.410051 15.5899C0.1475 15.3274 0 14.9713 0 14.6V1.4C0 0.6272 0.6272 0 1.4 0ZM1.2 1.4V14.6C1.2 14.7104 1.2896 14.8 1.4 14.8H10.4V1.2H1.4C1.34696 1.2 1.29609 1.22107 1.25858 1.25858C1.22107 1.29609 1.2 1.34696 1.2 1.4ZM11.6 14.8H14.6C14.653 14.8 14.7039 14.7789 14.7414 14.7414C14.7789 14.7039 14.8 14.653 14.8 14.6V1.4C14.8 1.34696 14.7789 1.29609 14.7414 1.25858C14.7039 1.22107 14.653 1.2 14.6 1.2H11.6V14.8Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseRight);
export default __webpack_public_path__ + "static/media/collapse-right.36ca248f959e31daafcc19d5c2c756fa.svg";
export { ForwardRef as ReactComponent };